import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';
import { OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
    providedIn: 'root'
})
export class JWTHttpInterceptor implements HttpInterceptor {

    private token: string = '';
    private _snackBar = inject(MatSnackBar);

    constructor(private authService: OepaIopAuthLibService) {

    }

    /**
     * Add JWT Token to request
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip adding Authorization header for S3 pre-signed URLs
        if (req.url.includes('amazonaws.com')) {
            return next.handle(req).pipe(
                catchError((error: HttpErrorResponse) => {
                    // Log the error to the console
                    console.error('HTTP Error:', error);
                    if (error.status === 404) {
                        // Suppress logging for 404 errors
                        console.warn(`404 Not Found: ${error.url}`);
                        return throwError(() => error); // Pass the error to the caller
                    }
                    this.openSnackBar(error.error.message, 'X');
                    return throwError(() => error);
                })
            );
        }
        this.token = this.authService.getAccessToken();
        const changedReq = req.clone({ setHeaders: { 'Authorization': 'Bearer ' + this.token } });
        return next.handle(changedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                // Log the error to the console
                console.error('HTTP Error:', error);
                if (error.status === 404) {
                    // Suppress logging for 404 errors
                    console.warn(`404 Not Found: ${error.url}`);
                    return throwError(() => error); // Pass the error to the caller
                }
                this.openSnackBar(error.error.message, 'X');
                return throwError(() => error);
            })
        );
    }
    
    private openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            horizontalPosition: 'start',
            panelClass: ['red-snackbar'],
            duration: 5000 // Snackbar will close after 5 seconds
        });
    }
}
